// ConfirmPH Legal Readiness Center: client helpers.
//
// Status vocabulary, tones, capability names and error handling all come
// from lib/platformLegal.js: this centre reads Task 2's facts and must
// present them identically.
import { api } from "./api";

export const LR = "/admin/legal-readiness";

export const lrGet = (path, config) => api.get(`${LR}${path}`, config).then((r) => r.data);
export const lrPost = (path, body) => api.post(`${LR}${path}`, body).then((r) => r.data);
export const lrPatch = (path, body) => api.patch(`${LR}${path}`, body).then((r) => r.data);
export const lrPut = (path, body) => api.put(`${LR}${path}`, body).then((r) => r.data);

export const MILESTONE_SHORT = {
  public_launch: "Public launch",
  paid_subscriptions: "Paid subscriptions",
  employment: "Hiring",
  equity_investment: "Equity investment",
  foreign_investment: "Foreign investor",
};

export const CATEGORY_LABELS = {
  entity: "Legal entity",
  local_government: "Local government",
  tax: "Tax",
  banking_payments: "Banking & payments",
  privacy: "Privacy",
  legal_documents: "Legal documents",
  e_commerce: "E-commerce",
  security: "Security",
  intellectual_property: "Intellectual property",
  employment: "Employment",
  investment: "Investment",
  insurance: "Insurance",
  recurring: "Recurring filings",
};

export const PLAN_LABELS = {
  not_planned: "Not planned",
  planned: "Planned",
  active: "Active now",
  none: "No employees",
  employed: "Employing now",
  exploring: "Exploring",
  in_progress: "In progress",
  completed: "Completed",
};

export function planLabel(value) {
  return PLAN_LABELS[value] || value;
}
